<template>
  <div class="banner">
    <van-image
      class="bannerImg"
      fit="cover"
      :src="img"
    />
    <div class="cover">
      <div>
        <div class="title" :style="{paddingTop: desc ? '' : '40px'}">{{ title }}</div>
        <div class="desc">{{ desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'topImg',
  data() {
    return {};
  },
  props: {
    img: String,
    title: String,
    desc: String
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {}
  }
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 589px;
  display: block;
  position: relative;
  .bannerImg {
    width: 100%;
    height: 100%;
  }
  .cover {
    width: 100%;
    height: 100%;
    padding-top: 426px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    // background: rgba(0, 0, 0, 0.2);
    > div {
      width: 1200px;
      height: auto;
      margin: 0 auto;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc {
        font-size: 24px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 33px;
        margin-top: 14px;
        width: 63%;
      }
    }
  }
}
@media (max-width: 1000px) {
  .banner {
    height: 348px;
    .cover {
      padding-top: 192px;
      padding-left: 52px;
      > div {
        width: auto;
        .title {
          font-size: 34px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 400;
        }
        .desc {
          font-size: 40px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
